import { Examples } from '@/types';

export const ExampleMStoreReferenceSelectionModalRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleMStoreReferenceSelectionModal,
        components: {
          default: () => import(/* webpackChunkName: "ExampleMStoreReferenceSelectionModal" */
            '@/views/examples/ExampleMStoreReferenceSelectionModal.vue')
        }
      }
    ]
    : [];